import { render } from "./ContactCompany.vue?vue&type=template&id=6a1b3472"
import script from "./ContactCompany.vue?vue&type=script&lang=js"
export * from "./ContactCompany.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__